import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import * as api from "../../../constants/api_constants";

// formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { post } from "helpers/api_helper";

const moduleOptions = [
  {
    value: 0,
    label: "Parent",
  },
  { value: 1, label: "Child" },
];

export default function AddModule() {

  const [moduleData, setModuleData] = useState([]);
  const navigate = useNavigate();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      modulename: "",
      modulecode: "",
      displayorder: "",
      moduleType: 0,
      selectedModuleId: "",
      selectedModuleName: "",
      selectedModuleCode: "",
      selectedDisplayOrder: 0,
      selectedModuleParentId: 0,
      selectedModuleURLValue: "",
    },

    validationSchema: Yup.object({
      modulename: Yup.string().required("Please enter module name"),
      modulecode: Yup.string().required("Please enter module code"),
      displayorder: Yup.string()
        .required("Please enter display order")
        .matches(/^[0-9]*$/, "Please enter only number"),
    }),

    onSubmit: async (values) => {
      try {
        let modulePostData = [
          {
            moduleName: values.modulename,
            moduleCode: values.modulecode,
            displayOrder: values.displayorder,
            moduleURLValue: `/${values.modulename
              .trim()
              .toLowerCase()
              .replaceAll(" ", "-")}`,
          },
        ];

        if (values.moduleType == 1) {
          modulePostData = [
            {
              moduleId: parseInt(values.selectedModuleId),
              moduleName: values.selectedModuleName,
              moduleCode: values.selectedModuleCode,
              displayOrder: values.selectedDisplayOrder,
              moduleURLValue: values.selectedModuleURLValue,
              ModuleParentId: 5,
              childModules: [
                {
                  moduleId: null,
                  moduleName: values.modulename,
                  moduleCode: values.modulecode,
                  displayOrder: values.displayorder,
                  moduleURLValue: `/${values.modulename
                    .trim()
                    .toLowerCase()
                    .replaceAll(" ", "-")}`,
                  moduleParentId: parseInt(values.selectedModuleId),
                },
              ],
            },
          ];
        }

        const data = {
          moduleTOs: modulePostData,
        };

        const ModuleData = await post(api.CREATE_MODULE, data);
        navigate("/users/modules");
      } catch (err) {
        console.log(err);
      }
    },
  });

  const fetchData = async () => {
    try {
      const ModuleData = await post(api.GET_ALL_MODULES, {
        body: { moduleId: 0 },
      });

      if (ModuleData) {
        setModuleData(ModuleData?.moduleTOs);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleCustomChange = (e) => {
    if (e.target.name === "moduleType" && e.target.value == 1) {
      fetchData();
    }

    validation.handleChange(e);
  };

  const customHandleSelectModule = (e) => {
    const moduleId = parseInt(e.target.value) || 0;
    if (moduleId) {
      const selectedModule = moduleData.find(
        (each) => each.moduleId == moduleId
      );
      if (selectedModule) {
        validation.setFieldValue(
          "selectedModuleName",
          selectedModule.moduleName
        );
        //         selectedModuleCode: "",
        //   selectedDisplayOrder: 0,
        //   selectedModuleParentId: 0,
        //   selectedModuleURLValue: "",
        validation.setFieldValue(
          "selectedModuleCode",
          selectedModule.moduleCode
        );
        validation.setFieldValue(
          "selectedDisplayOrder",
          selectedModule.displayOrder
        );
        validation.setFieldValue(
          "selectedModuleURLValue",
          selectedModule.moduleURLValue
        );
      }
    }

    validation.handleChange(e);
  };

  return (
    <>
      <div className="page-content">
        <Container fluid={true}>
          <Row className="py-4">
            <Col>
              <Card>
                <CardBody>
                  <h4 className="card-title text-primary">Add Module</h4>
                  <Form
                    className="row g-3 needs-validation py-4"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <Row>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationCustom06">
                            Module Name<span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="modulename"
                            placeholder=""
                            type="text"
                            className="form-control"
                            id="validationCustom02"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.modulename || ""}
                            invalid={
                              validation.touched.modulename &&
                              validation.errors.modulename
                                ? true
                                : false
                            }
                          />
                          {validation.touched.modulename &&
                          validation.errors.modulename ? (
                            <FormFeedback type="invalid">
                              {validation.errors.modulename}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationCustom02">
                            Module Type <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="select"
                            name="moduleType"
                            id="validationCustom02"
                            onChange={handleCustomChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.moduleType}
                            invalid={
                              validation.touched.moduleType &&
                              validation.errors.moduleType
                                ? true
                                : false
                            }
                          >
                            {moduleOptions.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.modulecode &&
                          validation.errors.modulecode ? (
                            <FormFeedback type="invalid">
                              {validation.errors.modulecode}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationCustom02">
                            Module Code <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="modulecode"
                            placeholder=""
                            type="text"
                            className="form-control"
                            id="validationCustom02"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.modulecode || ""}
                            invalid={
                              validation.touched.modulecode &&
                              validation.errors.modulecode
                                ? true
                                : false
                            }
                          />
                          {validation.touched.modulecode &&
                          validation.errors.modulecode ? (
                            <FormFeedback type="invalid">
                              {validation.errors.modulecode}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="validationCustom03">
                            Display Order <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="displayorder"
                            placeholder=""
                            type="text"
                            className="form-control"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.displayorder || ""}
                            invalid={
                              validation.touched.displayorder &&
                              validation.errors.displayorder
                                ? true
                                : false
                            }
                          />
                          {validation.touched.displayorder &&
                          validation.errors.displayorder ? (
                            <FormFeedback type="invalid">
                              {validation.errors.displayorder}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className="my-6"></div>
                    <div className="my-6"></div>
                    <div className="my-6"></div>

                    {validation.values.moduleType == 1 ? (
                      <Row>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom02">
                              Select Module{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="select"
                              name="selectedModuleId"
                              id="validationCustom10"
                              onChange={customHandleSelectModule}
                              onBlur={validation.handleBlur}
                              value={validation.values.selectedModuleId}
                              invalid={
                                validation.touched.selectedModuleId &&
                                validation.errors.selectedModuleId
                                  ? true
                                  : false
                              }
                            >
                              <option value="0">Select</option>
                              {moduleData.map((option) => (
                                <option
                                  key={option.moduleId}
                                  value={option.moduleId}
                                >
                                  {option.moduleName}
                                </option>
                              ))}
                            </Input>
                            {validation.touched.modulecode &&
                            validation.errors.modulecode ? (
                              <FormFeedback type="invalid">
                                {validation.errors.modulecode}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom02">
                              Module Code <span className="text-danger">*</span>
                            </Label>
                            <Input
                              name="selectedModuleCode"
                              placeholder=""
                              type="text"
                              className="form-control"
                              id="validationCustom02"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.selectedModuleCode || ""}
                              invalid={
                                validation.touched.selectedModuleCode &&
                                validation.errors.selectedModuleCode
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.selectedModuleCode &&
                            validation.errors.selectedModuleCode ? (
                              <FormFeedback type="invalid">
                                {validation.errors.selectedModuleCode}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom03">
                              Display Order{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <Input
                              name="selectedDisplayOrder"
                              placeholder=""
                              type="text"
                              className="form-control"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={
                                validation.values.selectedDisplayOrder || ""
                              }
                              invalid={
                                validation.touched.selectedDisplayOrder &&
                                validation.errors.selectedDisplayOrder
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.selectedDisplayOrder &&
                            validation.errors.selectedDisplayOrder ? (
                              <FormFeedback type="invalid">
                                {validation.errors.selectedDisplayOrder}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                      </Row>
                    ) : null}
                    <div className="col-12">
                      <button
                        className="btn  btn-primary float-end mx-3"
                        type="submit"
                      >
                        Save
                      </button>
                      <button
                        className="btn w-md btn-primary float-end"
                        type="button"
                        onClick={() => navigate("/modules")}
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
